// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconChartHistogram } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconChartHistogram
};
const metrics: NavItemType = {
    id: 'metrics',
    title: <FormattedMessage id="Metrics" />,
    icon: icons.IconChartHistogram,
    type: 'group',
    url: '/metrics'
};

export default metrics;
